import { render, staticRenderFns } from "./leave_form.vue?vue&type=template&id=3423e210"
import script from "./leave_form.vue?vue&type=script&lang=js"
export * from "./leave_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports